import { render } from "./leftBar1.vue?vue&type=template&id=062505d6"
import script from "./leftBar1.vue?vue&type=script&lang=js"
export * from "./leftBar1.vue?vue&type=script&lang=js"

import "./leftBar1.vue?vue&type=style&index=0&id=062505d6&lang=less"
script.render = render

export default script